export const RECEIVE_ITEMS = 'RECEIVE_ITEMS'
export const RECEIVE_ITEM = 'RECEIVE_ITEM'
export const RECEIVE_ITEMS_ERROR = 'RECEIVE_ITEMS_ERROR'
export const RECEIVE_ITEM_ERROR = 'RECEIVE_ITEMS_ERROR'
export const CLEAR_ITEMS = 'CLEAR_ITEMS'
export const DELETE_RELATED_ITEM_CONTENT = 'DELETE_RELATED_ITEM_CONTENT'
export const RECEIVE_RELATED_ITEM_CONTENT = 'RECEIVE_RELATED_ITEM_CONTENT'
export const REMOVE_SELECTED_ITEM = 'REMOVE_SELECTED_ITEM'
